<div class="footer">
  <div class="ebu-container-full-grey">
    <div class="row">
      <div class="container">
        <div class="row">
          <div class="col-md-3 ebu-doormat-column ebu-h2-fill">
            <h2>Our Services</h2>

            <!--c'est juste pour avoir l'alignement vertical-->

            <ul>

              <li><a href="/about/academy">Academy</a></li>

              <li><a href="/about/digital-media">Digital Media</a></li>

              <li><a href="/about/dg-office">Director General's Office</a></li>

              <li><a href="/about/european-affairs">European Affairs</a></li>

              <li><a href="https://www.eurovision.net" target="_blank">Eurovision Media Services</a></li>

              <li><a href="/about/legal">Legal</a></li>

            </ul>

            <div class="clear"></div><div class="clear"></div>
          </div>
          <div class="col-md-3 ebu-doormat-column ebu-h2-fill">
            <!--c'est juste pour avoir l'alignement vertical-->

            <h2 class="empty">&nbsp;</h2>

            <ul>

              <li><a href="/about/media-intelligence">Media Intelligence</a></li>

              <li><a href="/about/news">News</a></li>

              <li><a href="/about/radio">Radio</a></li>

              <li><a href="/about/sport">Sport</a></li>

              <li><a href="https://tech.ebu.ch" target="_blank">Technology &amp; Innovation</a></li>

              <li><a href="/about/tv">TV</a></li>

            </ul>

            <div class="clear"></div><div class="clear"></div>
          </div>
          <div class="col-md-3 ebu-doormat-column ebu-h2-fill">
            <h2>Our Members</h2>

            <!--c'est juste pour avoir l'alignement vertical-->

            <ul>

              <li><a href="/about/members">EBU Members</a></li>

              <li><a href="/about/members/admission">Admission</a></li>

              <li><a href="/groups?type=committee">Committees</a></li>

              <li><a href="/groups">Groups</a></li>

              <li><a href="/about/governance-and-internal-audit">Governance</a></li>

            </ul>

            <div class="clear"></div><div class="clear"></div>
          </div>
          <div class="col-md-3 ebu-doormat-column ebu-h2-fill">
            <h2>About Us</h2>

            <!--c'est juste pour avoir l'alignement vertical-->

            <ul>

              <li><a href="/about">About Us</a></li>

              <li><a href="/about/contact-us">Contact Us</a></li>

              <li><a href="/careers">Careers</a></li>

              <li><a href="/about/communications">Communications</a></li>

              <li><a href="/about/newsletters">Newsletters</a></li>

              <li><a href="https://www.ebu.ch/modules/SamlLogin?goto=http%3A%2F%2Fwww.ebu.ch%2Ffor-ebu-staff">For EBU Staff</a></li>

              <li><a href="/terms-and-conditions">Terms &amp; Conditions</a></li>

            </ul>

            <div class="clear"></div><div class="clear"></div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <hr>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="h-line"></div>

            <div class="social">
              <ul class="list-inline">

                <li><a href="https://twitter.com/EBU_HQ" target="_blank"><span class="fa fa-twitter"></span></a></li>

                <li><a href="https://www.facebook.com/EBU.HQ" target="_blank"><span class="fa fa-facebook"></span></a></li>

                <li><a href="https://www.linkedin.com/company/ebu" target="_blank"><span class="fa fa-linkedin"></span></a></li>

                <li><a href="https://www.flickr.com/photos/ebu-uer/" target="_blank"><span class="fa fa-flickr"></span></a></li>

                <li><a href="https://www.youtube.com/user/EBUEurovision" target="_blank"><span class="fa fa-youtube"></span></a></li>

                <li><a href="http://www3.ebu.ch/cms/en/sites/ebu/rss/content-area/latest_EBU_news.rss" target="_blank"><span class="fa fa-rss"></span></a></li>

              </ul>
            </div>

            <div class="clear"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="corporate-ui">
  <footer>
    <div id="corp-footer">
      <div class="container">
        <div class="row">
          <div class="hidden-xs-down col-sm-3 col-md-3">
            <div class="powered-by">This website is powered by<br>
              <img class="footer-img-responsive" id="ebu_footer_x2" src="/assets/images/ebu_footer_x2.png">
            </div>
          </div>
          <div class="col-xs-9 col-sm-4 col-md-4">
            <div class="copyright">Copyright EBU <span id="footer-year">2017</span>. All rights reserved.<br>
              <span id="version-properties">v</span> <span id="server-properties">2.0</span>
            </div>
          </div>
          <div class="col-xs-3 col-sm-5 col-md-5">
            <div class="right-content">
              <div class="back-to-top" (click)="goToTop()">
                <i class="fa fa-arrow-up fa-inverse"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
</div>


// WEBPACK FOOTER //
// ./src/app/corporate-ui-footer/corporate-ui-footer.component.html